<template lang="pug">
div.contact
	.contact-cols
		div.contact-cols-item(v-for="column in content.key")
			figure(v-bind:class="column.type")
				<template v-if="column.info">
					img(v-bind:src="column.info.img")
					h3 {{ column.info.name }}
					p {{ column.info.copy }}
				</template>
				<template v-else>
					<LogoDark class="contact-logo" />
					p.
						{{column.detail.title}} <br>
						{{column.detail.street}} <br>
						{{column.detail.city}}
					p
						a(v-bind:href="'tel:' + matchPhoneNum(column.detail.phone)") {{column.detail.phone}}
						br
						a(v-bind:href="'mailto:' + column.detail.mail") {{column.detail.mail}}
					.contact-socials
						a(v-for="item, index in column.detail.socials"
							v-bind:href="item"
							v-bind:class="index"
							v-bind:title="index"
							target="_blank")
				</template>
</template>

<script>
import LogoDark from './logo-dark.svg';

export default {
	name: 'Columns',
	props: ['content'],
	methods: {
		matchPhoneNum(el){
			return el.replace(/\s/g, '');
		}
	},
	components: {
		LogoDark
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Columns/index.vue